var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-timeline-element"},[_c('div',{staticClass:"line-top",class:{ transparent: _vm.type === 'INITIAL' }}),_c('div',{staticClass:"dot",class:_vm.type}),_c('div',{staticClass:"line-bottom",class:{ transparent: _vm.isLastMeasure }})])
}
var staticRenderFns = []

export { render, staticRenderFns }